import { Canvas } from "./core/Canvas";

export class Salmon {
    public canvas: Canvas;

    constructor(app_container: HTMLElement){
        this.canvas = new Canvas(app_container);
    }

    public salmon_ASCII(){
        console.log(`

                        *(###%(*.
                        *#/../#%%%%##*
                    / //(,*(,,    .,*#(#%%#*.
                    *  /.  /( .*(#,%*(/#(#*/%%%#/.
                    *.  ,#*(/    ./#,.**  .#%#((%%%%%/.
                    .*,  *(*  *. ., .,,(. ,&/*(((&#(#(#%(
                        //,  *,,*  . .,      %(***/(&((%#((#%%*
                        (,**..,           .#/,*,/(&(//**#(((##%/
                            //(#(*//**,..,,*#,.. ,,(#&((**/****/#((#%/
                            .#***    ,/(*.      .*(%/*(#/*,,*,/(*(#%##%*
                            ,(, .,*.*.     .,/(##. .  **,...**///(#/(#%(
                                *(/((*  .  ,*,(#*//*,      //,,(//.(,.**((%&&&#*,
                                **%&#/***,/(,. .   **,. ,, ,(*..*,.#./,/*/%&#&%#%%%(,
                                ,#&&&#   #**,.       .*,...   ,,.,  ,(..*.(/%%#(##%##%%#.
                                **#&%/##(,..           .*.. .   .. ,,../,* ./(&#*##%###%####/
                                    ,//(%(*/%..              .* .  . ,. . ..*/*,.(%#//(/##&%((/#,
                                    ,//((*/(.                 ., .    *.  ..**/ ,(%%%./(/#*///
                                    ,,(.*(...                  *. ,..  ,.   */..,.#&%/((**//
                                    .(,* **..                  .,.,,.  .,  ..*  ..%&%((#(,*
                                        ((   ./.                   .....   ,,,,,*  (*%%%%,/
                                        .    .(.                  .,..     ,,.,* .,/&%#/
                                                .(.                  . ...   ,,.. ./,#%&(
                                                    *(.                    ..   , ,. /*((&%*
                                                    #/ /.                 .   ,. ,, .,,%%#
                                                    /#,#(                 , . ,.. / ,/#&%.
                                                    ,#%%#(                . . *  ,//**%%#
                                                    /#%%%(*               . . . ((./,(%%(
                                                    .#%#%#/(*              . . ,(( .*/#%%
                                                        .(/*//.             . ..*  *(%#%%.
                                                        .#(/((/            .   ,/*%/((#%.
                                                        .##(.,*(               .* .*##&(
                                                    ,%#(.,* *               .,#*/#%&.
                                                /((*,*,.. / /            .*./,#%&,
    #%&@@&&&&%%%%(,                         ,(*****,..      ,/          *#*/#%*
        .(%&%%%%&#&%(((#%%(*,..       .,,/#*. .....           (/*.,,//**.//#(.
            *%#%&%##((/**.,,,*/*/..                        . ,#/** .%##%%/.
            /###/**#,.../,.,,..               . .** (***/((##(**((
            .##%##((#/((,.    ...         *(#%%#(/**//*. ((*/*%,
                (###(/,,...*/*,..*.   ,*.#/             *#/**/#.
                ,##((%((,.../*,  ,.,/*#,          .*##((((/
                    #((*///%/,   .**(*           (,((*.
                    /(###/*#/,.(/#*
                    ,#(##((%###,
                        ###/(###.
                        ##(#(,


        `);
    }
}